// React Imports
import * as React from "react";
import {useState, useEffect, createContext} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import {Stack, Tooltip} from "@mui/material";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Typography from "@mui/material/Typography";

// App Imports
import {
    executeExpression
} from "../../ContractDataPoint/ContractDataPointClient";
import Button from "@mui/material/Button";
import {
    advanceApprovedByGuild,
    advanceContract,
    getMissingInput
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import WorkQueueDrawer from "../ContractDataPoints/WorkQueueDrawer";

import {
    applyDefault, getBulkEditListV2,
    updateRelatedExpressions
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";


// main function
export default function BulkEditGrid(props) {



    const [bulkEditCDP, setBulkEditCDP] = useState([]);
    const [selectedCDP, setSelectedCDP] = useState([]);



    const selectorContractSectionId = useSelector((state) => state.workQueueSlc.value.selectedContractSectionId);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorContractStatus = useSelector((state) => state.workQueueSlc.value.selectedContractStatus);
    const selectorContractProperty = useSelector((state) => state.workQueueSlc.value.bulkEditPropertyId);
    const selectorContractLevel = useSelector((state) => state.workQueueSlc.value.selectedContractLevel);
    const selectorContractGuild = useSelector((state) => state.workQueueSlc.value.selectedContractGuild);
    const selectorContractList = useSelector((state) => state.workQueueSlc.value.mousedContractContractList);

    const moreSeriesId = useSelector((state) => state.workQueueSlc.value.bulkEditSeriesId);
    const moreSeasonId = useSelector((state) => state.workQueueSlc.value.bulkEditSeasonId);
    const morePropertyId = useSelector((state) => state.workQueueSlc.value.bulkEditPropertyId);

    const selectorInputMissingCount = useSelector((state) => state.workQueueSlc.value.selectedContractInputMissingCount);


    const cdpFilter = useSelector((state) => state.workQueueSlc.value.bulkEditGridPencil);

    const selectorTriggerAdvance = useSelector((state) => state.workQueueSlc.value.triggerAdvance);
    const selectorControlsRefreshCdpGrid =  useSelector((state) => state.workQueueSlc.value.workQueueCDPGridRefresh);





    const dispatchData = useDispatch();


    const CDPcontext = createContext();

    useEffect(() => {
        console.log("CDP fetch triggered by cdp refresh = true");
        fetchBulkEditList();
        dispatchData(changeWorkQueue({bulkEditGridState: true, bulkEditGridRefresh: false}));
    }, [useSelector((state) => state.workQueueSlc.value.bulkEditGridRefresh)===true]);


    const handleBackButton = () => {
        dispatchData(changeWorkQueue({bulkEditPropertyId: 0,bulkEditGridState: false}));
    };


    const handleFilter = () => {
        if (cdpFilter === 'red') {
            dispatchData(changeWorkQueue({bulkEditGridPencil: 'black'}));
        }
        if (cdpFilter === 'black') {
            dispatchData(changeWorkQueue({bulkEditGridPencil: 'red'}));
        }
    }

    const handleDefault  = (defaultData) => {
        console.log("Default Data");
        console.log(defaultData);
        applyDefault(defaultData.cdpvId, defaultData.defaultValueSource, defaultData.defaultValue, defaultData.defaultValueValue)
            .then(dispatchData(changeWorkQueue({bulkEditGridState: true, bulkEditGridRefresh: true})))
    };

    useEffect(() => {
        console.log("CDP fetch triggered by cdp filter");
        fetchBulkEditList();
    }, [cdpFilter]);

    const fetchBulkEditList = () => {
            if (moreSeriesId != null || moreSeasonId != null || morePropertyId != null
        ) {
                console.log("Fetching bulk edit data for the following contracts:");
                console.log(selectorContractList);
                getBulkEditListV2(selectorContractList)

                .then(data => {
                    console.log("for Contract #", selectorContractId);
                    console.log("CDP data set retrieved");
                    console.log(data);
                    setBulkEditCDP(data);

                    // *************************
                    if (selectorContractSectionId !== 0 && cdpFilter === 'all') {
                        setBulkEditCDP(data.filter(data => data.contractSectionId === selectorContractSectionId));
                    }
                    if (selectorContractSectionId !== 0 && cdpFilter === 'black') {
                        setBulkEditCDP(data.filter(data => (data.mockOrigin === 'Input' || data.mockOrigin === 'Assumption')
                            && data.contractSectionId === selectorContractSectionId)
                        )
                    }
                    if (selectorContractSectionId === 0 && cdpFilter === 'black') {
                        setBulkEditCDP(data.filter(data => (data.origin === 'Input' || data.origin === 'Assumption')
                        ))
                    }
                    if (selectorContractSectionId !== 0 && cdpFilter === 'blue') {
                        setBulkEditCDP(data.filter(data => ((data.origin === 'Input' || data.origin === 'Assumption') &&
                            data.value !== null) && data.contractSectionId === selectorContractSectionId)
                        )
                    }
                    if (selectorContractSectionId === 0 && cdpFilter === 'blue') {
                        setBulkEditCDP(data.filter(data => ((data.origin === 'Input' || data.origin === 'Assumption') &&
                            data.value !== null))
                        )
                    }
                  if ((selectorContractSectionId !== 0 && selectorContractSectionId !== null ) && cdpFilter === 'red') {
                        setBulkEditCDP(data.filter(data => (
                            (data.value === null || data.value === '') && data.contractSectionId === selectorContractSectionId
                        )))
                    }
                    if ((selectorContractSectionId === 0 ||  selectorContractSectionId === null ) && cdpFilter === 'red') {
                        setBulkEditCDP(data.filter(data => (
                            data.value === null || data.value === ''
                        )))
                    }
                })
        }
    };

    useEffect(() => {
        if(selectorControlsRefreshCdpGrid === true){
            console.log("CDP Grid refresh triggered by Work Queue workQueueCDPGridRefresh on Bulk Edit Grid...");
            fetchBulkEditList();
            dispatchData(changeWorkQueue({workQueueCDPGridRefresh: false}));}

    }, [useSelector((state) => state.workQueueSlc.value.workQueueCDPGridRefresh)===true]);


    // useEffect(() => {
    //     if(selectorCdpControlsRefreshCdpGrid === true){
    //         console.log("CDP fetch triggered by contractDataPointSlcControls.value.cdpGridRefresh)  on Bulk Edit Grid === true")
    //         fetchBulkEditList();
    //         dispatchData(changeContractDataPoint({cdpGridRefresh: false}));
    //         fetchBulkEditList();}
    // }, [useSelector((state) => state.contractDataPointSlc.value.cdpGridRefresh) === true]);

    const [submitting, setSubmitting] = useState(false);

    function handleAdvance(callback) {
        if (selectorContractId != null
            && selectorContractId !== 0 &&
            (selectorContractStatus === "NEW" || selectorContractStatus === "Unapproved" || selectorContractStatus === undefined  )
        ) {
            console.log("standard advance triggered");
            console.log("selectorContractId",selectorContractId);
            console.log("selectorContractStatus",selectorContractStatus);
            console.log("selectorContractProperty",selectorContractProperty);
            console.log("selectorContractLevel",selectorContractLevel);
            console.log("selectorContractGuild",selectorContractGuild);
            setSubmitting(true);
            // setAdvancing(true);
            advanceContract(selectorContractId).then(() => {

                fetchBulkEditList();

            })

                .then(() => {
                    dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
                })
                .finally(() => {
                    setSubmitting(false)
                })
        }
        if (selectorContractId != null
            && selectorContractId !== 0 &&
            selectorContractStatus === "Approved"
        ){              setSubmitting(true);
            console.log("advance approved triggered");
            console.log("selectorContractId",selectorContractId);
            console.log("selectorContractStatus",selectorContractStatus);
            console.log("selectorContractProperty",selectorContractProperty);
            console.log("selectorContractLevel",selectorContractLevel);
            console.log("selectorContractGuild",selectorContractGuild);
            advanceApprovedByGuild(selectorContractId, selectorContractProperty, selectorContractLevel, selectorContractGuild).then(() => {

                fetchBulkEditList();})
                .finally(() => {
                    setSubmitting(false)
                })
        }else{console.log("Advance Failed");
            console.log("selectorContractId", selectorContractId);
            console.log("selectorContractStatus", selectorContractStatus);};
    };


    const triggerAdvance = selectorContractId => {
        if (selectorContractId !== 0) {
            console.log("advance triggered by triggerAdvance")
            handleAdvance();
        }
    }

    useEffect(() => {
        if(selectorTriggerAdvance === true)
        {
            console.log("Advance triggered by workQueueSlc.value.triggerAdvance = true");
            triggerAdvance()
            // handleAdvance();
            dispatchData(changeWorkQueue({triggerAdvance: false}));}
    }, [useSelector((state) => state.workQueueSlc.value.triggerAdvance === true)]);



    const renderContractDataPoints2 = bulkEditCDP => {
        if (bulkEditCDP.length <= 0) {
            return "No Data";
        }
    }

    const handleExpression = (cdp_id, cs_id, callback) => {
        executeExpression(cdp_id).then(() => {
            callback(fetchBulkEditList);
            console.log("Execute Expression");
        });
    };

    const handleAllExpressions = () => {
        setSubmitting(true)
        updateRelatedExpressions(selectorContractId).then(()=>{
            dispatchData(changeWorkQueue({workQueueCDPGridRefresh: false}))
        })
            .finally(()=>{setSubmitting(false)});
    };


    const handleEdit = (rowData) => {
        // alert(rowData.contractId);
        console.log("Data for bulk editing");
        console.log("contract id", rowData.contractId);
        console.log("cdp id", rowData.cdpId);
        dispatchData(changeWorkQueue({selectedContractId: rowData.contractId, cdpId: rowData.cdpId, dataPointName: rowData.dataPointName,  dataType: rowData.dataType, value: rowData.cdpvDisplayValue,workQueueDrawerState: true,
            workQueueNewState: false, workQueueAdvanceState: false,
            selectedCdpId: rowData.id,
            selectedCdpDataPointId: rowData.dataPointId,
            selectedCdpDataPointName: rowData.dataPointName,
            selectedCdpDataType: rowData.dataType,
            selectedCdpMockValue: rowData.cdpvDisplayValue,
            selectedCdpValue: rowData.value,
            selectedCdpMockOrigin: rowData.origin}));
        // dispatchData(changeWorkQueue({workQueueDrawerState: true}));
        console.log("Begin edit");
        console.log("Work Queue Drawer State Updated to True");
        console.log("selected contract id at open");
        console.log("input missing count", selectorInputMissingCount);
        console.log("selectorContractId", selectorContractId);

        getMissingInput(selectorContractId)
    }



    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport                             fontSize="small" />
                </Box>
            </GridToolbarContainer>
        );
    }


    const columns = fetchBulkEditList => [
        {
            field: "cDPExplore",
            //https://codesandbox.io/s/material-demo-forked-2gtom?file=/demo.tsx
            renderHeader: () => {
                // <strong>
                // {"M"}
                // </strong>
                if (cdpFilter === 'black') {
                    return (
                        <EditIcon fontSize="small" style={{cursor: 'pointer'}} onClick={() => handleFilter()}/>
                    );
                }
                if (cdpFilter === 'blue') {
                    return (
                        <EditIcon fontSize="small" style={{cursor: 'pointer'}} color="primary" onClick={() => handleFilter()}/>
                    );
                }
                if (cdpFilter === 'red') {
                    return (
                        <EditIcon fontSize="small" style={{cursor: 'pointer'}} color="error" onClick={() => handleFilter()}/>
                    );
                }
                if (cdpFilter === 'all') {
                    return (
                        <AllInclusiveIcon fontSize="small" style={{cursor: 'pointer'}}  onClick={() => handleFilter()}/>
                    );
                }
            },
            headerName: '',
            disableColumnMenu: true,
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filterable: false,
            renderCell: (bulkEditCDP) => {
                if( bulkEditCDP.row.value === '' || bulkEditCDP.row.value === null ){
                    return (
                        <IconButton
                            size="small"
                            variant="contained"

                        >
                            <CDPcontext.Provider value={selectedCDP}>
                                <EditIcon fontSize="small" color="error" onClick= {() => handleEdit(bulkEditCDP.row)}/>
                            </CDPcontext.Provider>
                        </IconButton>
                    );}
                if((bulkEditCDP.row.origin=== 'Input' || bulkEditCDP.row.origin===  'Assumption') && bulkEditCDP.row.value !== null ){
                    return (
                        <IconButton
                            size="small"
                            variant="contained"

                        >
                            <CDPcontext.Provider value={selectedCDP}>
                                <EditIcon fontSize="small" color="primary" onClick= {() => handleEdit(bulkEditCDP.row)}/>
                            </CDPcontext.Provider>
                        </IconButton>
                    );}
            }
        },
        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            renderCell: (bulkEditCDP) =>{return <div className="rowId"
            onClick= {() => handleExpression(bulkEditCDP.row.id,  bulkEditCDP.row.contractSectionId, fetchBulkEditList)}
            style={{cursor:'pointer'}}
            >{bulkEditCDP.row.id}</div>;},
            // editable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'seriesId',
            headerName: 'Series ID',
            description: '',
            sortable: true,
            // editable: true,
            width: 30,
            hide: true,
        },
        {
            field: 'seriesName',
            headerName: 'Series Name',
            description: '',
            sortable: true,
            // editable: true,
            width: 150,
            hide: true,
        },
        {
            field: 'contractId',
            headerName: 'Contract ID',
            description: '',
            sortable: true,
            // editable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'seasonId',
            headerName: 'Season ID',
            description: '',
            sortable: true,
            // editable: true,
            width: 30,
            hide: true,
        },
        {
            field: 'seasonName',
            headerName: 'Season Name',
            description: '',
            sortable: true,
            // editable: true,
            width: 150,
            hide: true,
        },
                {
            field: 'seasonNumber',
            headerName: 'Season',
            description: '',
            sortable: true,
            // editable: true,
            width: 30,
            hide: true,
        },
        {
            field: 'propertyId',
            headerName: 'Property ID',
            description: '',
            sortable: true,
            // editable: true,
            width: 30,
            hide: true,
        },
        {
            field: 'propertyTitle',
            headerName: 'Title',
            description: '',
            sortable: true,
            // editable: true,
            width: 200,
            hide: false,
        },
        {
            field: 'principalPhotoDate',
            headerName: 'Photo Date',
            description: '',
            sortable: true,
            // editable: true,
            width: 70,
            hide: true,
        },
        {
            field: 'laborGroup',
            headerName: 'Labor Group',
            description: '',
            sortable: true,
            // editable: true,
            width: 120,
            hide: false,
        },
        {
            field: 'guild',
            headerName: 'Guild',
            description: '',
            sortable: false,
            // editable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'contractLevel',
            headerName: 'Level',
            description: '',
            sortable: false,
            // editable: true,
            width: 120,
            hide: false,
        },
        {
            field: 'contractName',
            headerName: 'Name',
            description: '',
            sortable: false,
            // editable: true,
            width: 200,
            hide: true,
        },
        {
            field: 'mashupName',
            headerName: 'Name',
            description: '',
            sortable: false,
            // editable: true,
            width: 300,
            hide: false,
        },
        {
            field: 'sectionName',
            headerName: 'Folder',
            description: '',
            sortable: false,
            // editable: true,
            width: 120,
            hide: false,
        },
        {
            field: 'cdpvId',
            headerName: 'ID',
            description: '',
            sortable: false,
            // editable: true,
            width: 50,
            hide: false,
        },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            description: '',
            sortable: false,
            // editable: true,
            width: 250,
            hide: false,
        },
        {
            field: 'value',
            headerName: 'Orig Value',
            description: '',
            sortable: false,
            // editable: true,
            width: 50,
            hide: true,
        },
        {
            field: 'displayValue',
            headerName: 'Value',
            description: '',
            sortable: false,
            // editable: true,
            width: 150,
            hide: false,
        },
        {
            field: 'arrow',
            headerName: '',
            description: '',
            sortable: false,
            renderCell: (bulkEditCDP) =>{
                if((bulkEditCDP.row.defaultValue !== '' && bulkEditCDP.row.defaultValue !== null && (bulkEditCDP.row.defaultValueSource === 'Value' || bulkEditCDP.row.defaultValueSource === 'Data Point Value' )) ||
                    (bulkEditCDP.row.defaultValueSource === 'Data Point' &&  bulkEditCDP.row.defaultValueValue !== 'na'   &&  bulkEditCDP.row.defaultValueValue !== '' && bulkEditCDP.row.defaultValueValue !== null)
                ){ return <div className="defaultArrow" onClick= {() => handleDefault(bulkEditCDP.row)}
                                                                   style={{cursor:'pointer'}}><ArrowCircleLeftIcon color="primary" /></div>;}
                if(
                    (bulkEditCDP.row.defaultValueValue === '' || bulkEditCDP.row.defaultValueValue === 'na' || bulkEditCDP.row.defaultValueValue === null)   && bulkEditCDP.row.defaultValueSource === 'Data Point'  )
                                { return <div className="defaultArrowError" ><ArrowCircleLeftIcon color="error" /></div>;}
                },
            // editable: true,
            width: 60,
            hide: false,
        },
        {
            field: 'defaultValue',
            headerName: 'Default',
            description: '',
            sortable: false,
            // editable: true,
            width: 100,
            hide: true,
        },
        {
            field: 'defaultValueSource',
            headerName: 'Default Source',
            description: '',
            sortable: false,
            // editable: true,
            width: 100,
            hide: false,
        },
        {
            field: 'displayDefaultValue',
            headerName: 'Default Value',
            description: '',
            sortable: false,
            // editable: true,
            width: 100,
            hide: false,
        },
        {
            field: 'defaultValueValue',
            headerName: 'Reference Value',
            description: '',
            sortable: false,
            // editable: true,
            width: 150,
            hide: true,
        },
        {
            field: 'displayDefaultValueValue',
            headerName: 'Default',
            description: '',
            sortable: false,
            // editable: true,
            width: 200,
            hide: false,
        },
        {
            field: 'origin',
            headerName: 'Origin',
            description: '',
            sortable: false,
            // editable: true,
            width: 120,
            hide: false,
        }
    ]


    return (
        <div style={{ height: '100%' , width: '100%' }}>
            <Stack direction="row" spacing={12}>
                <Box sx={{height: 70, pt: 1, pl: 3}}>
                <h3>Bulk Edit</h3>
            </Box>
                <Button onClick={() => handleBackButton()} >BACK</Button>
            </Stack>
            <Stack direction="row" spacing={2}>
                <Tooltip title={"refresh values"}>
                    <Box>
                        <RefreshIcon  color={'primary'}  style={{cursor:'pointer'}}
                                      onClick={() => handleAllExpressions()}
                        />
                    </Box>
                </Tooltip>
                <Box>
                    <Tooltip title={"contract id: " + selectorContractId}>
                        <Typography sx={{ fontWeight: 'bold' }}
                                    style={{cursor: 'pointer'}}
                        >Contract Data Points</Typography>
                    </Tooltip>
                </Box>
                <Tooltip title={"advance"}>
                    <Box>
                        <ArrowForwardIcon  color={'primary'}  style={{cursor:'pointer'}}
                                           onClick={() => handleAdvance( fetchBulkEditList)}
                        />
                    </Box>
                </Tooltip>

            </Stack>

            <WorkQueueDrawer/>
            <DataGridPro
                style={{ height: '800px' , width: '100%' }}
                aria-label={"BulkEditList"}
                rows={bulkEditCDP}
                rowThreshold={0}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchBulkEditList)}
                density={"compact"}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'ordinalNumber', sort: 'asc' }],
                    },
                }}
            />

        </div>
    );


}




